import React from "react";
import { useSelector } from "react-redux";
import { IStore } from "@/redux/defaultStore";
import ActiveMissionCard from "./ActiveMissionCard";
import type { FormattedChallenge } from "@/types/play";
import "./InGameCompactView.scss";

interface InGameCompactViewProps {
    challenges: FormattedChallenge[];
    challengesLoading: boolean;
    fuelBalance: string;
    accountLevel: any;
}

const InGameCompactView: React.FC<InGameCompactViewProps> = ({
    challenges,
    challengesLoading,
    fuelBalance,
    accountLevel,
}) => {
    const gameInfo = useSelector((store: IStore) => store.metaStore.overwolfGameInfo);

    return (
        <div className="in-game-compact">
            {/* Minimal Header */}
            <div className="compact-header">
                <div className="game-status">
                    <span className="game-icon">🎮</span>
                    <span className="game-name">{gameInfo?.title || "In Game"}</span>
                </div>
                <div className="quick-stats">
                    <span className="stat-item">
                        <span className="stat-label">LVL</span>
                        <span className="stat-value">{accountLevel?.level || 1}</span>
                    </span>
                    <span className="stat-item">
                        <span className="stat-label">FUEL</span>
                        <span className="stat-value">{fuelBalance}</span>
                    </span>
                </div>
            </div>

            {/* Active Mission - Compact Version */}
            <div className="compact-mission">
                <ActiveMissionCard
                    challenges={challenges}
                    isLoading={challengesLoading}
                />
            </div>

            {/* Minimal Progress Bar */}
            <div className="compact-progress">
                <div className="xp-bar">
                    <div
                        className="xp-fill"
                        style={{
                            width: `${accountLevel?.experienceGainedAtThisLevel /
                (accountLevel?.experienceGainedAtThisLevel + accountLevel?.experienceRequiredForNextLevel) * 100}%`,
                        }}
                    />
                </div>
                <div className="xp-text">
                    {accountLevel?.experienceGainedAtThisLevel?.toLocaleString()} / {" "}
                    {(accountLevel?.experienceGainedAtThisLevel + accountLevel?.experienceRequiredForNextLevel)?.toLocaleString()} XP
                </div>
            </div>

            {/* Minimal Action Bar */}
            <div className="compact-actions">
                <button className="action-btn" title="Quests">
                    <span>🎯</span>
                </button>
                <button className="action-btn" title="Challenges">
                    <span>🏆</span>
                </button>
                <button className="action-btn" title="Profile">
                    <span>👤</span>
                </button>
                <button className="action-btn action-btn--primary" title="Full View">
                    <span>⤢</span>
                </button>
            </div>
        </div>
    );
};

export default InGameCompactView;